var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CheckboxWithLabel',{class:_vm.$style.checkboxColor,attrs:{"classNames":_vm.classNames,"label":_vm.control.label,"tooltip":_vm.getTooltip(),"value":_vm.value},on:{"change":_vm.handleChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }